import $ from 'jquery';
import PxsMap from '@pixelunion/pxs-map/src/scripts/index';
import RimgShopify from '@pixelunion/rimg-shopify';
import ShopifySectionsManager from 'shopify-sections-manager';

// Shared Sections
import Slideshow from '@pixelunion/pxs-slideshow';
import Video from '@pixelunion/pxs-video';
import Testimonials from '@pixelunion/pxs-testimonials';
import { SiteAgeGate, PageAgeGate } from '@pixelunion/age-gate';

import './polyfills';

// Sections
import Product from './sections/Product';
import DynamicFAQ from './sections/DynamicFAQ';
import StaticHeader from './sections/StaticHeader';
import StaticCollection from './sections/StaticCollection';
import StaticFooter from './sections/StaticFooter';
import StaticCart from './sections/StaticCart';
import StaticBlog from './sections/StaticBlog';
import StaticProductRecommendations from './sections/StaticProductRecommendations';
import StaticSearch from './sections/StaticSearch';

// Templates
import Account from './templates/Account';
import Contact from './templates/Contact';
import GiftCard from './templates/GiftCard';

// Helpers
import flickityTouchFix from './helpers/FlickityTouchFix';
import { initShopifyProductReviews } from './helpers/ProductReviews';

// Components
import ImagesWithText from './components/ImagesWithText';
import RTE from './components/RTE';

// Utilities
import ThemeUtils from './utils/ThemeUtils';

export default class Startup {
  constructor() {
    const body = $(document.body);

    // Set up conditionals
    this.isHome = body.hasClass('template-index');
    this.isAccount = body.attr('class').indexOf('-customers-') > 0;

    this.isCollection = $('[data-section-type="static-collection"]').length;
    this.isProduct = $('[data-section-type="static-product"]').length;
    this.isProductSlideshow = $('[data-section-type="static-product-slideshow"]').length;
    this.isCart = $('[data-section-type="static-cart"]').length;
    this.isContactPage = $('[data-section-type="static-contact"]').length;
    this.isGiftCardPage = $('[data-section-type="static-giftcard"]').length;
    this.isBlog = $('[data-section-type="static-blog"]').length;
    this.isBlogPost = $('[data-section-type="static-article"]').length;
    this.is404 = $('[data-section-type="static-404"]').length;
    this.isSearch = $('[data-section-type="static-search"]').length;

    flickityTouchFix();

    // Common views
    this.sections = new ShopifySectionsManager();
    this.sections.register('pxs-header-standard', section => new StaticHeader(section));
    this.sections.register('static-footer', section => new StaticFooter(section));
    this.sections.register('pxs-map', section => new PxsMap(section));
    this.sections.register('pxs-video', section => new Video(section));
    this.sections.register('pxs-faq', section => new DynamicFAQ(section));

    RimgShopify.init();

    // Conditional views
    this.sections.register('dynamic-featured-product', section => new Product(section));
    this.sections.register('dynamic-image-with-text', section => new ImagesWithText(section));
    this.sections.register('dynamic-image-with-text-overlay', section => new ImagesWithText(section));
    this.sections.register('pxs-slideshow', section => new Slideshow(section));
    this.sections.register('pxs-testimonials', section => new Testimonials(section));
    this.sections.register('age-gate', section => new PageAgeGate(section));

    if (this.isCollection) {
      this.sections.register('static-collection', section => new StaticCollection(section));
    }

    if (this.isGiftCardPage) {
      this.sections.register('static-giftcard', section => new GiftCard(section));
    }

    if (this.isContactPage) {
      this.sections.register('static-contact', section => new Contact(section));
    }

    if (this.isProduct) {
      this.sections.register('static-product', section => new Product(section));
      this.sections.register('static-product-recommendations', section => new StaticProductRecommendations(section));
    }

    if (this.isCart) {
      this.sections.register('static-cart', section => new StaticCart(section));
    }

    if (this.isBlog) {
      this.sections.register('static-blog', section => new StaticBlog(section));
    }

    if (this.isBlogPost) {
      this.sections.register('static-article', section => new StaticBlog(section));
    }

    if (this.isSearch) {
      this.sections.register('static-search', section => new StaticSearch(section));
    }

    if (this.isAccount) {
      this.Account = new Account({ el: '.main-content' });
    }

    this.rtes = [];
    this.richTextInit();
    ThemeUtils.externalLinks($(document));

    $(document).on('shopify:section:load', (event) => {
      ThemeUtils.externalLinks($(event.target));
      this.richTextInit();
      initShopifyProductReviews();
    });

    this.classHoist();

    $(document)
      .on('shopify:section:select.home-page', () => this.classHoist())
      .on('shopify:section:load.home-page', () => this.classHoist())
      .on('shopify:section:deselect.home-page', () => this.classHoist());

    const ageGatePage = document.getElementById('age-gate-page');

    if (ageGatePage) {
      new SiteAgeGate(ageGatePage);
    }
  }

  getStyle($el) {
    const styleSetting = $el.attr('class').match(/(default|contrast|accent)-style/);

    if (styleSetting != null) {
      return styleSetting[0];
    }
    return false;
  }

  getSectionWidth($el) {
    const sectionWidthSetting = $el.attr('class').match(/content-width|full-width/);
    if (sectionWidthSetting !== null) {
      return sectionWidthSetting[0];
    }

    return false;
  }

  classHoist() {
    $('.module-container').each((index, section) => {
      const $section = $(section);
      const $parent = $section.parent();

      const sectionStyle = this.getStyle($section);
      const parentStyle = this.getStyle($parent);
      const sectionWidthStyle = this.getSectionWidth($section);

      if (sectionWidthStyle) {
        $parent.addClass(sectionWidthStyle);
      }

      if (!sectionStyle) { return; }

      if (parentStyle) { $parent.removeClass(parentStyle); }
      $parent.addClass(sectionStyle);
    });
  }

  richTextInit() {
    for (let i = 0; i < $('.rte').length; i++) {
      this.rtes.push(new RTE({ el: $('.rte')[i] }));
    }
  }
}

$(() => { window.theme = new Startup(); });
